export const generateSlug = (title: string, index: number): string => {
  return `${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}-${index}`;
};